// src/components/Kontakt.jsx
import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { apiClient } from "../services/apiClient";

const Kontakt = () => {
  const captchaRef = useRef(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);

  const validate = () => {
    const e = {};
    if (!form.name) e.name = "Bitte Namen angeben.";
    if (!form.email) e.email = "Bitte E-Mail angeben.";
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Ungültige E-Mail.";
    if (!form.message) e.message = "Nachricht darf nicht leer sein.";
    if (!captchaToken) e.captcha = "Bitte bestätigen Sie das Captcha.";
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setServerError(null);

    const v = validate();
    setErrors(v);
    if (Object.keys(v).length !== 0) return;

    setLoading(true);

    try {
      await apiClient("/contact", {
        method: "POST",
        body: {
          name: form.name,
          email: form.email,
          message: form.message,
          captchaToken,
        },
      });

      setSubmitted(true);
      setForm({ name: "", email: "", subject: "", message: "" });
      captchaRef.current.reset();
    } catch (err) {
      console.error(err);
      setServerError("Nachricht konnte nicht gesendet werden. Bitte später erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h1 className="card-title mb-4">Kontakt</h1>

        {submitted ? (
          <div className="alert alert-success">
            Danke! Ihre Nachricht wurde erfolgreich versendet.
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                name="name"
                value={form.name}
                onChange={onChange}
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.name}</div>
            </div>

            <div className="mb-3">
              <label className="form-label">E-Mail</label>
              <input
                name="email"
                value={form.email}
                onChange={onChange}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.email}</div>
            </div>

            <div className="mb-3">
              <label className="form-label">Betreff</label>
              <input
                name="subject"
                value={form.subject}
                onChange={onChange}
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Nachricht</label>
              <textarea
                name="message"
                value={form.message}
                onChange={onChange}
                rows="6"
                className={`form-control ${errors.message ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.message}</div>
            </div>

            <div className="mb-3">
              <ReCAPTCHA
                sitekey="6LcsijssAAAAAG7Narosga24AeTpIbu_Ffx7NCQr"
                onChange={(token) => setCaptchaToken(token)}
                ref={captchaRef}
              />
              {errors.captcha && (
                <div className="text-danger small mt-1">{errors.captcha}</div>
              )}
            </div>

            {serverError && (
              <div className="alert alert-danger">{serverError}</div>
            )}

            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Senden…" : "Nachricht senden"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() =>
                  setForm({ name: "", email: "", subject: "", message: "" })
                }
              >
                Zurücksetzen
              </button>
            </div>

            <p className="text-muted small mt-3">
              Ihre Angaben werden ausschließlich zur Bearbeitung Ihrer Anfrage
              verwendet.
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default Kontakt;
